import { render, staticRenderFns } from "./selldetail.vue?vue&type=template&id=135ac968&scoped=true&"
import script from "./selldetail.vue?vue&type=script&lang=js&"
export * from "./selldetail.vue?vue&type=script&lang=js&"
import style0 from "./selldetail.vue?vue&type=style&index=0&id=135ac968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ac968",
  null
  
)

export default component.exports